<template>
  <div>
    <Head title="Paneli" />

    <div class="flex flex-wrap items-center mb-6 lg:mb-6">

      <select-input v-model="form.orders_type"  class="pr-5 w-full lg:w-1/12" label="Dërgesat">
        <option value="active">Aktive</option>
        <option value="archived">Të arkivuara</option>
        <option value="all">Të gjitha</option>
      </select-input>

      <select-input v-model="form.area_type"  class="pr-5 w-full lg:w-1/12" label="Qytet/Fshat">
        <option :value="null">Të gjitha</option>
        <option value="qytet">Qytet</option>
        <option value="fshat">Fshat</option>
      </select-input>

      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label text-sm">Nga data:</label>
        <input v-model="form.start_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>

      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label text-sm">Deri në datën(duke mos e përfshirë):</label>
        <input v-model="form.end_date" type="date" class="form-select focus:ring-0 hover:border-indigo-500">
      </div>
    </div>


    <div class="flex flex-wrap items-center mb-6 lg:mb-6">
      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label">Shteti:</label>
        <Multiselect
          v-model="form.country_ids"
          :options="filterCountries.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>


      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label">Qyteti:</label>
        <Multiselect
          v-model="form.city_ids"
          :options="filterCities.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-2/12">
        <label class="form-label">Shoferi shpërndarës:</label>
        <Multiselect
          v-model="form.delivery_driver_ids"
          :options="filterDeliveryDrivers.options"
          mode="tags"
          :close-on-select="false"
          :searchable="true"
          :create-option="false"
          :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
        />
      </div>

      <div class="pr-5 w-full lg:w-1/12">
        <button class="mt-7 text-gray-500 hover:text-gray-700 focus:text-indigo-500 text-sm" type="button" @click="reset">Pastro</button>
      </div>
    </div>


    <div  class="flex flex-wrap mx-2 mb-6 lg:mb-6">
      <h3 class="text-sm font-bold pr-6 w-full lg:w-full">Dërgesa
        <hr></h3>




      <div v-if="this.ordersData" class="pl-3 pt-3 pr-10 pb-5 mr-5 mt-2  w-full lg:w-1/6 bg-red-500 rounded-md shadow">
        <h1 class="text-4xl text-white">
          <Link :href="getOrdersByStatusUrl(7)">{{ this.ordersData.cancelled }}</Link>
        </h1>
        <h1 class="text-2xl text-white">Të anuluara</h1>
        <h1 class="text-sm text-white">Total posta: {{this.ordersData.cancelled_cancelled_cost}}</h1>
      </div>
      <loading-ticket v-else></loading-ticket>

    </div>

  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput.vue'
import LoadingTicket from '@/Shared/LoadingTicket.vue'
import mapValues from 'lodash/mapValues'
import {computed} from 'vue'
import Multiselect from '@vueform/multiselect'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'


export default {
  components: {
    LoadingTicket,
    SelectInput,
    Head,
    Link,
    Multiselect
  },
  layout: Layout,
  props: {
    ordersData: Object,
    countries: Object,
    cities: Object,
    deliveryDrivers: Object,
    filters: Object,
  },

  data() {
    return {
      form: {
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
        country_ids: this.filters.country_ids,
        city_ids : this.filters.city_ids,
        delivery_driver_ids: this.filters.delivery_driver_ids,
        orders_type: this.filters.orders_type,
        area_type: this.filters.area_type ?? null
      },
      filterCountries: {
        options: this.countries.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterCities: {
        options: this.cities.map(function(country){
          return {value: country.id, label: country.name}
        }),
      },
      filterDeliveryDrivers: {
        options: this.deliveryDrivers.map(function(deliveryDriver){
          return {value: deliveryDriver.id, label: deliveryDriver.name}
        }),
      },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/admin/paneli', pickBy(this.form), {
          preserveState: true,
        });

      }, 150),
    },
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
      let multiselectClearButtons = document.getElementsByClassName('multiselect-clear')
      for(let i = 0 ; i < multiselectClearButtons.length; i++){
        multiselectClearButtons[i].click()
      }
    },
    getOrdersByStatusUrl(statusId){
      let url = "/admin/dergesat?barazuar=false&status_ids[]=" + statusId
      if(this.filters.start_date)
        url += ("&start_date_status_updated=" + this.filters.start_date)

      if(this.filters.end_date)
        url += ("&end_date_status_updated=" + this.filters.end_date)

      if(this.filters.country_ids)
        this.filters.country_ids.forEach(function(key,value){
          url += ("&country_ids[]=" + key)
        })

      if(this.filters.city_ids)
        this.filters.city_ids.forEach(function(key,value){
          url += ("&city_ids[]=" + key)
        })

      if(this.filters.delivery_driver_ids)
        this.filters.delivery_driver_ids.forEach(function(key,value){
          url += ("&delivery_driver_ids[]=" + key)
        })

      return url;
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>


<style src="@vueform/multiselect/themes/default.css"></style>
